import { Pipe, PipeTransform } from '@angular/core';
import { MatIconEnum, MatIconHlp, MatIconKey } from '../helpers/matIcon.helper';

@Pipe({ name: 'icon' })
export class MatIconPipe implements PipeTransform {
  transform(key: MatIconKey): string {
    return MatIconHlp.get(key as MatIconEnum);
  }
}
